import React from 'react'
import {SubHeader, ContactForm, Badge, Email} from '../'
import { CallRounded, EmailRounded, LocationCityRounded } from '@mui/icons-material'

import './contactUs.css'

const ContactUs = () => {
    
  return (
    <>
      <div id='contact-us' className='contact-us-wrapper'>
        <Badge title="Contact" />
        <SubHeader title="We'd love to Hear From You." description="Call Today: +214-254-6367" />

        {/* <CallToAction /> */}
        <div className='contact-us-action-wrapper'>
          <div className="contact-us-action-container">
            <div className="contact-us-action-grid">
              <div>
                <EmailRounded />
                <p className="contact-us-action-grid-title">Email Support</p>
                <p className="contact-us-action-grid-sub-title">Our team can respond in real time.</p>
                <a href="ular.shalomspringsofplano@gmail.com" className="contact-us-action-grid-main">
                  <Email />
                </a>
              </div>
              <div>
                <LocationCityRounded />
                <p className="contact-us-action-grid-title">Visit Our Office</p>
                <p className="contact-us-action-grid-sub-title">Visit our location.</p>
                <span className="contact-us-action-grid-main">
                  3509 Brookshire Dr Plano Tx 75075
                </span>
              </div>
              <div>
                <CallRounded />
                <p className="contact-us-action-grid-title">Call Us Directly</p>
                <p className="contact-us-action-grid-sub-title">Available during working hours.</p>
                <span className="contact-us-action-grid-main">
                  +214-254-6367
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className='contact-us-container'>
          <div className='contact-us-form-cover'>
            <ContactForm />
          </div>
        </div>
      </div>
    </>
  )
}

export default ContactUs